// @ts-check

import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
  GithubAuthProvider,
} from "firebase/auth";
import { app } from "./firebase_init";

/**
 * @import { UserCredential, User } from "firebase/auth";
 * @import { Result } from "./types/result";
 */

export const auth = getAuth(app);

/**
 * @param {UserCredential} userCredentials
 * @returns {Result<User>}
 */
function processUserCredentials(userCredentials) {
  console.log(userCredentials);
  return {
    result: userCredentials.user,
    error: null,
  };
}

/**
 * @param {any} err
 * @returns {Result<User>}
 */
function processError(err) {
  console.log(err);
  return {
    result: null,
    error: {
      code: err.code,
      message: err.message,
    },
  };
}

/**
 * @param {string} email
 * @param {string} pass
 */
export async function createUserEmailPass(email, pass) {
  try {
    const credentials = await createUserWithEmailAndPassword(auth, email, pass);
    return processUserCredentials(credentials);
  } catch (e) {
    return processError(e);
  }
}

/**
 * @param {string} email
 * @param {string} pass
 */
export async function loginUserEmailPass(email, pass) {
  try {
    const credentials = await signInWithEmailAndPassword(auth, email, pass);
    return processUserCredentials(credentials);
  } catch (e) {
    return processError(e);
  }
}

export async function loginUserGoogle() {
  try {
    const provider = new GoogleAuthProvider();
    provider.addScope("email");
    const credentials = await signInWithPopup(auth, provider);
    return processUserCredentials(credentials);
  } catch (e) {
    return processError(e);
  }
}

export async function loginUserGithub() {
  try {
    const provider = new GithubAuthProvider();
    provider.addScope("email");
    const credentials = await signInWithPopup(auth, provider);
    return processUserCredentials(credentials);
  } catch (e) {
    return processError(e);
  }
}

/**
 * @returns {Promise<Result<User>>}
 */
export async function logoutUser() {
  try {
    await signOut(auth);
    return {
      result: null,
      error: null,
    };
  } catch (e) {
    return processError(e);
  }
}

export function getUser() {
  return auth.currentUser;
}

export function getDisplayName() {
  return getUser().displayName;
}

export function getEmail() {
  return getUser().email;
}

export function getImage() {
  return getUser().photoURL;
}

export function getUID() {
  return getUser().uid;
}

export async function getToken() {
  return getUser().getIdToken();
}
